import React, { useContext } from 'react';
import CurrencyRatioPageContainerComponent from './CurrencyRatioPageContainer/CurrencyRatioPageContainer.container';
import { I18nContext } from 'utils/I18n/context';

const CurrencyRatioPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.currencyPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content finance">
                <CurrencyRatioPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

export default CurrencyRatioPage;
